<template>
  <b-table
    :data="limitLanes"
    :paginated="true"
    :per-page="10"
    :current-page="1"
    :hoverable="true"
    detailed
    :show-detail-icon="false"
    detail-key="id"
    class="preliminary-table"
    ref="table"
    scrollable
  >
    <b-table-column
      field="offerId"
      :label="$t('bnpl:limit.limit_lanes.list_header.offer_id')"
      v-slot="props"
      sort-icon="arrow-up"
      sort-icon-size="is-small"
      sortable
    >
      {{ props.row.offerId }}
    </b-table-column>
    <b-table-column
      field="minAmount"
      :label="$t('bnpl:limit.limit_lanes.list_header.min_amount')"
      v-slot="props"
      sort-icon="arrow-up"
      sort-icon-size="is-small"
      sortable
    >
      <template v-if="props.row.minAmount !== undefined">
        {{
          localizedFormatter(country.languageIso).money(
            currency,
            props.row.minAmount
          )
        }}
      </template>
    </b-table-column>
    <b-table-column
      field="maxAmount"
      :label="$t('bnpl:limit.limit_lanes.list_header.max_amount')"
      v-slot="props"
      sort-icon="arrow-up"
      sort-icon-size="is-small"
      sortable
    >
      <template v-if="props.row.maxAmount !== undefined">
        {{
          localizedFormatter(country.languageIso).money(
            currency,
            props.row.maxAmount
          )
        }}
      </template>
    </b-table-column>
    <b-table-column
      field="downPayment"
      :label="$t('bnpl:limit.limit_lanes.list_header.down_payment')"
      v-slot="props"
      sort-icon="arrow-up"
      sort-icon-size="is-small"
      sortable
    >
      {{ props.row.downPayment }} %
    </b-table-column>
    <b-table-column
      field="installments"
      :label="$t('bnpl:limit.limit_lanes.list_header.installments')"
      v-slot="props"
      sort-icon="arrow-up"
      sort-icon-size="is-small"
      sortable
    >
      {{ props.row.installments }}
    </b-table-column>
    <b-table-column
      field="limitValue"
      :label="$t('bnpl:limit.limit_lanes.list_header.limit_value')"
      v-slot="props"
      sort-icon="arrow-up"
      sort-icon-size="is-small"
      sortable
    >
      <template v-if="props.row.limitValue !== undefined">
        {{
          localizedFormatter(country.languageIso).money(
            currency,
            props.row.limitValue
          )
        }}
      </template>
    </b-table-column>

    <template #empty>
      <div class="has-text-centered">
        {{ $t("customer:customer.login_history.list.empty.message") }}
      </div>
    </template>
  </b-table>
</template>

<script>
import { formatMoney, formatDateTime, localizedFormatter } from "@/utils/util";
import { mapGetters } from "vuex/dist/vuex.common.js";

export default {
  props: {
    currency: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      limitLanes: [],
      loaded: true,
    };
  },
  computed: {
    ...mapGetters({
      country: "i18n/country",
    }),
  },
  methods: { formatMoney, formatDateTime, localizedFormatter },
  async created() {
    // await this.$store.dispatch("limit/fetchOne", this.id);
    this.limitLanes = this.$store.getters["limit/getLimitLanes"];
  },
};
</script>

<style lang="scss">
.action-icon {
  cursor: pointer;
}
</style>
